import { MeasurementSystemEnum } from "@cai-services";
import { MeasurementUnits } from "../core/_models/measurement-system.model";
import { Rate } from "../core/_models/rate.model";

function compare (a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function getIndexForRate (rate: Rate) {
  const type =
    rate.weightTypeRate.weightType !== "KG"
      ? rate.weightTypeRate.weightType
      : rate.weightTypeRate.weightType.toLowerCase(),
   value = rate.weightTypeRate.weight
    ? String(rate.weightTypeRate.weight)
    : "";
  return type + value;
}

function getAllInRate (quote): number {
  if (quote.rateDetail && quote.rateDetail.allInRate) {
    return quote.rateDetail.allInRate;
  } else if (
    quote.quoteRequest &&
    quote.quoteRequest.originalQuotePrice &&
    quote.quoteRequest.originalQuotePrice !== 0
  ) {
    return quote.quoteRequest.originalQuotePrice;
  }
  return null;
}

function getWeightUnit (measurementSystem: MeasurementSystemEnum): string {
  return MeasurementUnits[measurementSystem].WEIGHT.display;
}

function validateAmountText (
  amountText: string,
  currency: string,
  size: number,
  cedOffset: number,
  zero = "Z"
) {
  let amount: number;
  amountText = amountText.trim();
  if (amountText.length == 0) {
    return { "value": "", "error": null };
  }
  if (amountText.includes(" ")) {
    return { "value": amountText, "error": "invalid numeric" };
  }
  const ced = getCurrencyCed(currency);
  amountText = amountText.split(",").join("");
  if (ced == 0) {
    amount = parseInt(amountText);
  } else {
    amount = parseFloat(amountText);
  }
  if (isNaN(amount)) {
    return { "value": amountText, "error": "invalid numeric" };
  }
  amountText = formatMoneyToString(amount, currency, zero);
  if (amount - Math.pow(10, size - (cedOffset ? cedOffset : ced)) >= 0) {
    return { "value": amountText, "error": "size exceeded" };
  }
  return {
    "value": amountText,
    "error": null,
  };
}

function getAmountFromFormattedString (
  amountText: string,
  currency: string,
  emptyValue: number
): number {
  if (!amountText) {
    return emptyValue;
  }
  amountText = amountText.trim();
  let amount = 1;
  if (amountText.length > 0) {
    if (amountText.charAt(amountText.length - 1) == " ") {
      amountText = amountText.slice(0, amountText.length - 1);
    } else if (amountText.charAt(amountText.length - 1) == "-") {
      amountText = amountText.slice(0, amountText.length - 1);
      amount = -1;
    }
  }
  if (amountText.length == 0) {
    return emptyValue;
  }
  if (amountText.includes(" ")) {
    return;
  }
  amountText = amountText.split(",").join("");
  if (getCurrencyCed(currency) == 0) {
    amount = amount * parseInt(amountText);
  } else {
    amount = amount * parseFloat(amountText);
  }
  return amount;
}

function formatMoneyToString (
  amount: number,
  currency: string,
  zero = "Z"
): string {
  if (amount == null) {
    return "";
  }
  if (amount == 0 && zero == "Z") {
    return "";
  }
  const ced = getCurrencyCed(currency);
  return amount.toLocaleString("en-US", {
    "maximumFractionDigits": ced,
    "minimumFractionDigits": ced,
  });
}

function getCurrencyCed (currency: string): number {
  if (currency == null) {
    return 2;
  } else if (!isNaN(+currency)) {
    return +currency;
  } else if ("BHD,IQD,JOD,KWD,LYD,OMR,TND".includes(currency)) {
    return 3;
  } else if (
    "CVE,DJF,GNF,INR,IDR,ISK,JPY,KMF,KRW,PYG,RWF,UGX,VND,VUV,XAF,XOF,XPF".includes(
      currency
    )
  ) {
    return 0;
  } else {
    return 2;
  }
}

export {
  compare,
  getIndexForRate,
  getAllInRate,
  getWeightUnit,
  getCurrencyCed,
  formatMoneyToString,
  getAmountFromFormattedString,
  validateAmountText,
};
